goog.provide("shadow.js.shim.module$date_fns$locale$zh_CN$default");
shadow.js.shim.module$date_fns$locale$zh_CN$default = esm_import$date_fns$locale$zh_CN.default;
